import { Badge } from "@/projects/NPS/Stepper/components/ui/badge";

export const InvestorsDetails = () => {
  return (
    <section className="bg-custom-gradient py-14">
      <div className="container mx-auto px-6">
        <div className="mx-auto mb-8 max-w-2xl text-center">
          <Badge className="inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-green-100 px-4 py-2 text-sm font-medium text-green-600 backdrop-blur-sm">
            <span className="h-2 w-2 animate-pulse rounded-full bg-green-400" />
            Trusted by 50,000+ Investors
          </Badge>
        </div>
        <div className="mx-auto mb-4 text-center">
          <h2 className="font-nunito text-2xl font-bold leading-tight text-black md:text-3xl lg:text-4xl">
            The Digital Wealth Mall for All Your Investments
          </h2>
        </div>
        <div className="mx-auto mb-4 text-center">
          <p className="mx-auto max-w-2xl font-nunito text-base leading-relaxed text-muted-foreground md:text-lg">
            Seamlessly manage and track all your investments with cutting-edge
            technology and expert tools – empowering you to make informed
            decisions for a secure and prosperous financial future.
          </p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-4 pt-4 md:gap-8">
          {/* Item 1 */}
          <div className="text-foreground/80 flex items-center gap-2 text-sm font-medium md:text-base">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-circle-check h-5 w-5 text-green-600"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            SEBI & RBI Compliant
          </div>

          {/* Item 2 */}
          <div className="text-foreground/80 flex items-center gap-2 text-sm font-medium md:text-base">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-circle-check h-5 w-5 text-green-600"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            Secure Investments
          </div>

          {/* Item 3 */}
          <div className="text-foreground/80 flex items-center gap-2 text-sm font-medium md:text-base">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="lucide lucide-circle-check h-5 w-5 text-green-600"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="m9 12 2 2 4-4" />
            </svg>
            Expert Support
          </div>
        </div>
      </div>
    </section>
  );
};
